"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUDGET_SHARE_OF_BUDGET_COPY = exports.BUDGET_SHARE_OF_INCOME_COPY = void 0;
exports.budgetReviewShare = budgetReviewShare;
exports.budgetReviewDetail = budgetReviewDetail;
exports.budgetShareText = budgetShareText;
function budgetReviewShare(args) {
    const { amount, totalBudget, monthlyIncome } = args;
    if (monthlyIncome != null && monthlyIncome > 0) {
        return { pct: Math.round((amount / monthlyIncome) * 100), graded: true };
    }
    return {
        pct: totalBudget > 0 ? Math.round((amount / totalBudget) * 100) : 0,
        graded: false,
    };
}
/**
 * The line beside the bucket's name. Each client formats its own percentages
 * (`formatPct`), so this takes them as strings; `target` is null when the share
 * is not graded.
 */
function budgetReviewDetail(pct, target) {
    return target == null
        ? `${pct}% of your budget`
        : `${pct}% of income (target ${target}%)`;
}
/**
 * A group's share, with no target beside it (BEN-141: Anthony, 18 Sep, "no real value
 * in telling an end user their needs are below some percentage … get rid of that";
 * Paul, 2026-10-08). Replaces `budgetReviewDetail`'s "(target X%)" form. That function
 * stays until neither client calls it, then is retired (rule 17: an existing key).
 */
exports.BUDGET_SHARE_OF_INCOME_COPY = "% of income";
exports.BUDGET_SHARE_OF_BUDGET_COPY = "% of your budget";
function budgetShareText(pct, ofIncome) {
    // Named *_COPY constants so scripts/copy-inventory.mjs lists them (a string returned
    // from inside a function is never extracted).
    return `${pct}${ofIncome ? exports.BUDGET_SHARE_OF_INCOME_COPY : exports.BUDGET_SHARE_OF_BUDGET_COPY}`;
}
//# sourceMappingURL=budgetReviewCopy.js.map